define(["require", "exports", "knockout", "../utils/dateUtils"], function (require, exports, ko, dateUtils) {
    "use strict";
    var CustomerPlanModel = /** @class */ (function () {
        function CustomerPlanModel(data) {
            this.Id = ko.observable(0);
            this.CustomerName = ko.observable();
            this.CustomerId = ko.observable(0);
            this.CallPlanId = ko.observable(0);
            this.Name = ko.observable();
            this.PlanType = ko.observable();
            this.BTN = ko.observable();
            this.TotalSotfphoneLicenses = ko.observable(0);
            this.IsCustom = ko.observable();
            this.ServiceTypeId = ko.observable(0);
            this.ProductTypeId = ko.observable(0);
            this.ProviderId = ko.observable(0);
            this.EmployeeId = ko.observable(0);
            this.EmployeeName = ko.observable();
            this.PlanTermType = ko.observable(0);
            this.PlanTermTypeName = ko.observable();
            this.PlanTermStartDate = ko.observable();
            this.PlanTermEndDate = ko.observable();
            var self = this;
            if (data) {
                ko.mapping.fromJS(data, CustomerPlanModel.Mapping, self);
            }
        }
        CustomerPlanModel.Mapping = {
            key: function (data) {
                return data.Id;
            },
            create: function (options) {
                return new CustomerPlanModel(options.data);
            },
            PlanTermStartDate: {
                update: function (options) { return dateUtils.parseIsoDate(options.data); }
            },
            PlanTermEndDate: {
                update: function (options) { return dateUtils.parseIsoDate(options.data); }
            }
        };
        return CustomerPlanModel;
    }());
    return CustomerPlanModel;
});
//# sourceMappingURL=CustomerPlanModel.js.map


//////////////////
// WEBPACK FOOTER
// ./build/models/CustomerPlanModel.js
// module id = 68
// module chunks = 2